"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INPUT_CURRENCY = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.INPUT_CURRENCY = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-input-currency");
